module.exports = __webpack_public_path__ + "img/log-plus.ec16bfbe.svg";